<template>
    <div id="welfare">
        <div class="hero hero-drops" data-aos="fade-up">
            <svg class="drop-gray-1" width="439" height="531" viewBox="0 0 439 531" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M322.2 0L26 296.2C10 312.2 10 338.2 26 354.3C42 370.3 68 370.3 84.1 354.3L438.4 0H322.2Z" fill="url(#paint0_linear-svg-1)"/>
                <path d="M277.9 195.1L12 460.9C-4 476.9 -4 502.9 12 519C28 535 54 535 70.1 519L336 253.1C352 237.1 352 211.1 336 195C328 187 317.5 183 307 183C296.4 183.1 285.9 187.1 277.9 195.1Z" fill="url(#paint1_linear)"/>
                <defs>
                <linearGradient id="paint0_linear-svg-1" x1="109" y1="218" x2="615" y2="-14" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="77.8982" y1="390.109" x2="512.043" y2="218.305" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="drop-gray-2" width="224" height="223" viewBox="0 0 224 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.1 111.5C223.1 173.1 173.2 223 111.6 223C49.9999 223 0.0998535 173.1 0.0998535 111.5C0.0998535 49.9 49.9999 0 111.6 0C173.2 0 223.1 49.9 223.1 111.5Z" fill="#EDF0F7"/>
            </svg>          

            <div class="slider">
                <Slick ref="slick-hero-home" :options="slickOptions">
                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/welfare/hero.png" />
                        </div>
                        <div class="caption">
                            <div class="text h1">Online travel booking per il welfare aziendale</div>
                            <div class="small h4">
                                integrato e a misura del tuo lavoratore
                            </div>
                        </div>
                    </div>
                </Slick>

                <!--
                <div class="slider--nav">
                    <div id="hero-slider-prev" class="arrow"><SvgChevronLeft /></div>
                    <div id="hero-slider-next" class="arrow"><SvgChevronRight /></div>
                </div>
                -->
            </div>

            <ScrollTo selector="#scroll" />
        </div>

        <section class="extraQuote" id="scroll" data-aos="fade-up">
            <b-container class="text-center">
                <div class="image">
                    <svg width="1546" height="552" viewBox="0 0 1546 552" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M193.076 13.8771C155.827 23.3719 119.454 37.9793 88.6328 61.059C57.8111 84.1388 33.1245 116.421 23.3375 153.524C10.6291 201.875 18.6632 252.124 4.49396 300.475C-7.33805 340.791 4.64004 384.175 35.1696 413.536C64.9687 442.167 108.353 454.583 149.546 451.223C190.739 447.864 229.887 429.751 262.753 404.48C280.136 391.187 296.204 375.703 315.778 366.062C351.566 348.241 394.512 351.747 433.222 362.118C471.932 372.489 508.888 389.142 548.182 396.592C587.476 404.041 631.591 400.974 662.559 375.703C687.683 355.253 700.83 322.824 705.212 290.688C709.595 258.698 706.235 225.1 691.627 196.47C673.952 161.85 641.962 137.018 610.556 113.938C581.487 92.6111 552.126 71.7225 520.428 54.4857C454.549 18.5514 379.174 0 303.8 0C266.551 0 229.302 4.5283 193.076 13.8771Z" fill="url(#paint0_linear)"/>
                    <path d="M1503 551L259.625 517.346C245.026 517.346 232.226 501.361 228.026 477.803L166.429 167.683C160.03 132.01 175.929 96 198.028 96H1435.97C1450.57 96 1463.37 112.154 1467.57 135.543L1543.56 479.317C1549.96 514.99 1539 555 1503 551Z" fill="#FDC500"/>
                    <path d="M1478 516H252C223 516 210.226 500.014 206.026 476.457L144.429 132.683C138.029 97.0096 155 61 194 61H1417C1450 61 1455.77 77.1538 1459.97 100.543L1521.56 444.317C1527.96 479.99 1512 516 1478 516Z" fill="#39414E"/>
                    <path d="M397.529 112.1L374.029 169.5C385.529 177.3 391.229 190.4 391.229 204.5C391.229 230.6 372.429 248.8 346.829 248.8C323.329 248.8 302.529 233.1 302.529 204.5C302.529 190.9 307.729 179.5 314.529 169L353.629 112.1H397.529ZM489.329 204.4C489.329 230.5 470.529 248.7 445.029 248.7C421.529 248.7 400.729 233 400.729 204.4C400.729 190.8 405.929 179.4 412.729 168.9L451.829 112H495.629L472.129 169.4C483.629 177.3 489.329 190.3 489.329 204.4Z" fill="white"/>
                    <defs>
                    <linearGradient id="paint0_linear" x1="352.758" y1="484.869" x2="352.758" y2="59.2169" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF974F"/>
                    <stop offset="0.00128142" stop-color="#FF974F"/>
                    <stop offset="1" stop-color="#FF5652"/>
                    </linearGradient>
                    </defs>
                    </svg>
                </div>
                <div class="text">
                    Il lavoratore dell'era Covid e post-Covid è sempre più consapevole dell'importanza del suo benessere psico-fisico e di quello della sua famiglia. Il viaggio e la vacanza sono elementi imprescindibili di questa consapevolezza e il travel è diventato un tipo di servizio essenziale nei piani di welfare delle aziende più innovative e socialmente responsabili.
                </div>
            </b-container>
        </section>

        <section class="boxed-text" data-aos="fade-up">
            <p class="text text-center h4">
                Le nostre soluzioni di travel booking per il welfare aziendale sono diverse dalle altre:
            </p>
            <br>
            <p class="text text-center h2">sono soluzioni travel progettate per il welfare aziendale</p>
            <br>
            <p class="text text-center">
                Nella stragrande maggioranza, le soluzioni di travel booking per il welfare aziendale che si trovano oggi in Italia sono adattamenti di servizi consumer.
                <br><br>
                Il risultato di questi adattamenti è quasi sempre quello di una Esperienza Utente confusa e incerta di fronte ad interfacce spesso troppo complesse e ridondanti.
            </p>
        </section>

        <br><br>

        <b-container fluid class="valore" data-aos="fade-up">

            <svg class="top" width="957" height="316" viewBox="0 0 957 316" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M868.302 119.6C857.802 127.7 850.502 139.3 846.002 151.8C843.702 158.4 842.002 165.3 838.502 171.3C832.002 182.3 819.802 188.8 807.702 192.7C795.502 196.6 782.702 198.6 770.902 203.4C759.002 208.2 747.802 216.7 743.802 228.8C740.602 238.7 742.702 249.6 747.102 259C751.502 268.3 758.202 276.8 767.102 281.9C777.802 288.1 790.702 289.2 803.102 290C814.602 290.7 826.102 291.2 837.602 290.3C873.502 287.6 908.202 270.9 932.602 244.4C940.902 235.4 948.202 225.1 952.402 213.6C956.602 202.1 957.702 189.1 953.902 177.5C948.902 162.3 938.002 150.3 933.502 134.8C929.702 121.9 919.002 112.4 905.602 109.8C903.102 109.3 900.502 109.1 897.902 109.1C887.302 109.1 876.702 113.1 868.302 119.6Z" fill="url(#paint0_linear_top)"/>
                <path d="M87.2025 173.1C80.5025 175.7 76.2025 182.3 73.5025 188.9C70.7025 195.5 69.1025 202.7 65.4025 208.8C60.5025 217 52.0025 222.9 42.8025 225C32.1025 227.5 21.5025 224.4 11.5025 230.5C5.80249 234 1.60252 239.9 0.402517 246.5C-2.79748 264 13.7025 270.8 27.9025 275.1C33.3025 276.7 39.0025 277.2 44.7025 277.4C50.9025 277.6 57.0025 277.5 63.2025 277.3C73.6025 277.1 84.2025 276.8 94.1025 273.3C99.3025 271.4 104.103 268.7 109.203 266.5C116.203 263.4 124.402 262.4 131.202 259.2C130.402 256.9 126.203 255.3 124.303 253.5C121.603 250.9 119.503 247.7 118.203 244.2C112.603 229.5 118.203 216.1 117.703 201.2C117.403 193.1 115.002 184.8 109.502 178.8C105.402 174.5 99.5025 171.7 93.7025 171.7C91.4025 171.9 89.3025 172.3 87.2025 173.1Z" fill="url(#paint1_linear_top)"/>
                <path d="M473.803 258.2C470.503 260.9 467.802 264.3 464.102 266.4C458.802 269.4 452.402 269.2 446.602 270C439.902 270.9 433.302 272.4 427.202 275.4C420.002 278.9 413.802 285.1 410.602 292.5C408.702 297.1 408.402 302.8 411.202 307C413.702 310.8 418.202 312.9 422.702 314C433.702 316.9 444.803 314.8 453.303 307.6C454.303 306.7 455.303 305.8 456.303 304.8C462.103 298.5 466.102 290.7 472.902 285.4C479.802 280 488.302 276.3 497.102 276.2C498.202 276.2 499.203 276.2 500.303 276.2C502.203 276.3 504.102 276.3 506.002 276.1C508.902 275.7 511.903 274.6 513.703 272.2C515.603 269.6 515.503 265.9 514.203 263C512.903 260.1 510.402 257.8 507.702 256.1C503.202 253.2 497.802 251.8 492.402 251.8C485.602 251.9 478.903 254 473.803 258.2Z" fill="url(#paint2_linear_top)"/>
                <path d="M683.802 0C674.202 0.2 665.202 4.70001 656.602 9.20001C641.502 17 626.402 24.9 611.202 32.7C580.802 48.4 546.402 64.6 513.802 54.5C495.902 48.9 481.202 36.1 464.002 28.6C446.802 21.1 423.402 20.9 412.702 36.3C407.202 44.2 406.402 54.5 401.202 62.6C394.602 73 382.102 78.1 370.002 79.6C362.802 80.5 355.502 80.4 348.202 80.3C343.202 80.2 338.302 80.2 333.302 80.4C329.702 80.6 325.802 81 322.902 83.2C319.002 86.1 317.702 91.4 317.402 96.3C316.502 114.7 327.102 132.2 341.602 143.5C356.102 154.8 374.102 160.6 392.002 164.7C457.202 179.5 525.202 172.8 589.102 155.1C621.102 146.2 652.302 134.5 682.702 121.2C699.902 113.6 721.602 106.9 730.102 88.5C743.002 60.6 736.702 26.7 710.902 9.59998C702.902 4.29998 693.802 0 684.302 0C684.202 0 684.002 0 683.802 0Z" fill="url(#paint3_linear_top)"/>
                <defs>
                <linearGradient id="paint0_linear_top" x1="849.019" y1="304.101" x2="849.019" y2="132.915" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_top" x1="65.4635" y1="285.264" x2="65.4635" y2="185.57" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint2_linear_top" x1="462.036" y1="319.91" x2="462.036" y2="260.118" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint3_linear_top" x1="526.53" y1="185.501" x2="526.53" y2="22.6552" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg> 

            <svg class="down" width="1464" height="144" viewBox="0 0 1464 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M66.1225 2.35313C53.2225 4.95313 40.9225 10.6531 30.5225 18.6531C18.1225 28.1531 8.42247 40.8531 3.42247 55.6531C-7.57753 88.3531 8.52246 131.253 43.3225 141.353C75.9225 150.753 113.222 130.853 119.122 96.5531C122.322 77.7531 124.822 59.6531 144.122 50.8531C148.022 49.0531 152.222 47.8531 156.122 45.7531C177.022 34.4531 144.822 18.1531 135.522 13.2531C120.022 5.15312 102.522 0.453125 85.0225 0.453125C78.7225 0.453125 72.3224 1.05313 66.1225 2.35313Z" fill="url(#paint0_linear_down)"/>
                <path d="M1366.57 27.5531C1363.37 28.0531 1360.88 30.6531 1359.78 33.6531C1358.68 36.6531 1358.87 40.0531 1359.57 43.1531C1362.17 54.8531 1372.87 64.3531 1384.87 65.4531C1389.07 65.8531 1393.47 65.3531 1397.47 66.4531C1403.37 68.0531 1407.67 72.7531 1412.37 76.3531C1417.77 80.4531 1423.57 84.0531 1429.97 86.2531C1437.57 88.8531 1446.28 88.9531 1453.78 85.8531C1458.38 83.9531 1462.57 80.1531 1463.57 75.2531C1464.47 70.7531 1462.77 66.1531 1460.47 62.1531C1454.77 52.3531 1445.37 45.9531 1434.37 45.0531C1433.07 44.9531 1431.68 44.9531 1430.28 44.9531C1421.78 45.2531 1413.38 47.9531 1404.78 46.9531C1396.08 45.9531 1387.47 42.5531 1381.07 36.3531C1378.97 34.2531 1377.08 31.9531 1374.78 30.1531C1372.78 28.5531 1370.28 27.4531 1367.78 27.4531C1367.48 27.4531 1367.07 27.4531 1366.57 27.5531Z" fill="url(#paint1_linear_down)"/>
                <defs>
                <linearGradient id="paint0_linear_down" x1="81.352" y1="154.178" x2="81.3519" y2="19.2274" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_down" x1="1411.3" y1="92.6437" x2="1411.3" y2="35.4148" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="left" width="228" height="479" viewBox="0 0 228 479" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M74.7999 451C55.6999 474.6 29 484.2 0 475V44.6104C7.33642 40.4863 14.7283 36.4635 22.2 32.6002C41 22.9002 60.5 14.0002 81.2 9.4002C135.1 -2.6998 201.5 -11.0999 223.1 52.0001C231.2 75.8 228.7 102.9 216.3 124.7C194.6 162.8 154.5 172.3 124.3 200C98.0999 224.1 81.0999 258.6 80.2999 294.4C79.6999 321.2 87.2999 347.5 90.4999 374.2C93.6999 400.9 91.6999 430.1 74.7999 451Z" fill="url(#paint0_linear_left)"/>
                <defs>
                <linearGradient id="paint0_linear_left" x1="113.652" y1="513.449" x2="113.651" y2="63.5174" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="right" width="151" height="761" viewBox="0 0 151 761" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M63.9866 26.9161C29.4133 54.5284 10.1543 98.6152 8.06603 142.934C5.9777 187.021 19.6678 231.108 41.7112 269.393C53.313 289.581 67.4671 308.84 75.1243 330.883C89.0465 371.257 79.301 416.272 62.8264 455.718C46.3519 495.164 23.6124 532.058 10.3864 572.664C-3.07169 613.27 -5.85612 660.374 16.6513 696.803C34.7501 726.272 67.2351 744.602 100.88 753.884C117.123 758.293 134.061 760.845 151 760.845V0.464071C147.287 0.232035 143.807 0 140.094 0C112.946 0 86.03 9.28143 63.9866 26.9161Z" fill="url(#paint0_linear_right)"/>
                <defs>
                <linearGradient id="paint0_linear_right" x1="75.3414" y1="816.608" x2="75.34" y2="99.732" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>            

            <section>

                <br>

                <div class="paragraph text-center h2">
                    <h2 class="h2">Le nostre soluzioni sono progettate con in mente l'utente di welfare aziendale e personas definite.</h2>
                </div>
                
                <br><br>

                <p class="paragraph text-center h4">
                    Rispondiamo, in questo modo, alle specifiche esigenze dell'utente welfare.
                </p>
                
                <br>

                <div class="boxes yellow">
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">con una gestione trasparente e automatizzata del credito welfare</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">con il rispetto delle normative fiscali che regolano il settore</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">con la gestione delle normative di protezione della privacy</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                </div>

                <br><br><br>

                <p class="paragraph text-center h4">
                    e rispondiamo alle modalità d'uso di personas diverse e ben definite
                </p>
                
                <br>

                <div class="boxes yellow">                    
                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">personas con diversi livelli di skill nell'uso di interfacce online di travel booking</span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                          <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                          <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                              <stop offset="0.00128142" stop-color="#FF974F"/>
                              <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                          </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                personas che usano dispositivi e browser molto diversi
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                personas che operano in contesti e orari molto specifici (ufficio, casa, commuting, pausa pranzo, weekend, ecc.)
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                </div>

                <br><br>
                <br><br>

            </section>

        </b-container>

        <section class="section--card-cofanetti credito-travel" data-aos="fade-up">
            <b-container fluid>
                <div class="content">
                    <img class="bg" src="img/welfare/credito-travel.png" />
                    <h2 class="title h4 white">Il benessere e lo svago dei tuoi dipendenti in mani sicure</h2>
                </div>
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        Anche la nostra customer care è pensata per il tuo dipendente e non per un generico utente.
                        <br><br>
                        Le aziende clienti mettono nelle nostre mani, complessivamente, milioni di euro di budget welfare ma soprattutto i sogni e il tempo libero delle risorse più preziose di ogni azienda, i propri lavoratori.
                    </div>
                </div>
            </b-container>
        </section>

        <section class="boxed-text" data-aos="fade-up">
            <p class="text-center h4">
                <b>
                    Ecco cosa facciamo per dare serenità alle aziende che ci affidano il benessere e il tempo libero dei loro collaboratori:
                </b>
            </p>
        </section>

        <b-container fluid data-aos="fade-up">
            <section class="b-cards">
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions">
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/welfare/card-1.png')"></div>
                                                <div class="b-card--text">
                                                    <h4 class="b-card--title">La tecnologia per la qualità e la sicurezza</h4>
                                                    <p class="b-card--link">
                                                        Grazie ad un avanzato algoritmo affiancato dal lavoro del nostro staff di customer care cerchiamo di proporre ai tuoi dipendenti strutture e hotel di qualità, gestiti con professionalità.
                                                        <br><br>
                                                        Ma non ci fermiamo qui e controlliamo, una seconda volta, direttamente e prima dell'arrivo del viaggiatore, il 100% delle prenotazioni già confermate online. 
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/welfare/card-2.png')"></div>
                                                <div class="b-card--text">
                                                    <h4 class="b-card--title">Assistenza multicanale anche su WhatsApp</h4>
                                                    <p class="b-card--link">
                                                        Dal telefono alla webchat, dall'email a WhatsApp il tuo dipendente troverà sempre un modo per ottenere il nostro supporto
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/welfare/card-3.png')"></div>
                                                <div class="b-card--text">
                                                    <h4 class="b-card--title">Un centro di assistenza interno all'azienda dedicato all'utenza welfare</h4>
                                                    <p class="b-card--link">
                                                        Il nostro staff di assistenza conosce in profondità le esigenze dell’utente welfare, gli aspetti fiscali relativi a questa utenza, le logiche di gestione del credito welfare e riesce, quindi, a fornire risposte appropriate a differenza del servizio di assistenza di un normale sito di travel booking.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/welfare/card-4.png')"></div>
                                                <div class="b-card--text">
                                                    <h4 class="b-card--title">Una cultura aziendale di servizio</h4>
                                                    <p class="b-card--link">
                                                        I tuoi dipendenti troveranno sempre un personale di assistenza attento e disponibile.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </Slick>
                            </div>

                            <div class="b-left" id="b-left">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   

        <section class="section--card-cofanetti credito-travel mb-0 pb-0" data-aos="fade-up">
            <b-container fluid>
                <div class="content">
                    <img class="bg" src="img/welfare/credito-travel-2.png" />
                    <h2 class="title h4">Un'esperienza d'uso semplice e diretta grazie alle nostre soluzioni integrate</h2>
                </div>
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        Grazie alle nostre semplici e perfettamente documentate API e con l'uso di soluzioni di Single Sign-on realizziamo integrazioni tra la tua intranet o portale welfare e i nostri servizi in pochi giorni.
                    </div>
                </div>
            </b-container>
        </section>

        <section class="boxed-text mt-0" data-aos="fade-up">
            <p class="text-center h4 mt-0">
                <b>
                    Passando dal tuo sito al nostro l'utente si porterà dietro il suo welfare wallet e potrà così concludere la sua prenotazione in pochi click con un addebito immediato e trasparente
                </b>
            </p>
        </section>

        <br><br><br>

        <section class="boxed-text" data-aos="fade-up">
            <p class="text-center h2">
                <b>
                    Leader del travel booking per il welfare
                </b>
            </p>

            <br>

            <p class="text-center h4">
                <b>
                    Trovi i servizi Salabam srl integrati all'interno di tutti i più importanti portali di welfare aziendale italiani
                </b>
            </p>
        </section>

        <!--partners-->
        <section class="section" data-aos="fade-up">
            <b-container fluid>
            <div class="partners">

                <b-row>
                <b-col sm="12">
                    <p class="text-center"><b>I nostri partners</b></p>
                </b-col>
                </b-row>

                <br><br>

                <b-row>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/aon.png" /></b-col>
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/autogrill.png" /></b-col>-->
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/beneficy.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/confindustria-vicenza.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/doubleyou.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/easy-welfare.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/eudaimon.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/fiamm.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/health-italia.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/jakala.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/jointly.png" /></b-col>
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/konica-minolta.png" /></b-col>-->
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/mooney.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/motivation-network.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/pellegrini.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/poste-welfare.png" /></b-col>
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/pragma-comunicazione.png" /></b-col>-->
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/promarsa.png" /></b-col>-->
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/promoshopping.png" /></b-col>
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/proxima.png" /></b-col>-->
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/randstad.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/safilo.png" /></b-col>
                <!--<b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/sisalpay.png')" </b-col>-->
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/sodexo.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/ticket-compliments.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/timeswapp.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/unindustria.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/upday.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/welfare-bit.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/well-work.png" /></b-col>
                <b-col sm="12" md="4" lg="3" xl="2" class="partner"><img src="img/partners/willis.png" /></b-col>
                </b-row>
            </div>
            </b-container>
        </section>

        <section class="boxed-text" data-aos="fade-up">
            <p class="text-center h2">
                <b>
                    Un'ampia gamma gamma di prodotti adatti ad ogni esigenza di welfare aziendale
                </b>
            </p>

            <br>

            <p class="text-center">
                La tecnologia Vivamod (by Salabam) permette la creazione di proposte travel estremamente variegate e flessibili riuscendo a rispondere ad ogni esigenza di comunicazione dell'azienda anche in modo customizzato.
            </p>
        </section>

        <b-container data-aos="fade-up">
            <section class="text-left">
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions2">
                                    <div v-for="(i,index) in [1,2,3,4,5,6]" v-bind:key="index">
                                    <div class="b-slide">
                                        <div class="content">
                                            <img class="phone" src="img/home/slider-sintonizzati/phone.png" />
                                            <img class="screen" :src="'img/welfare/Vivamod_IN_VadoBay_'+i+'.jpg'" />
                                        </div>
                                    </div>
                                    </div>
                                </Slick>
                            </div>

                            <div class="b-left" id="b-left-2">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right-2">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   





        <b-container>
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="Per approfondire meglio le nostre soluzioni e quello che possiamo fare per il tuo welfare aziendale"
                />
            </section>
        </b-container>

        <section class="section--prefooter">
            <b-container fluid>
                <b-row>
                    <b-col sm="6">
                        <div class="content">
                            <h3 class="subtitle">
                                Secondo welfare<br>e welfare aziendale in Italia
                            </h3>
                            <div class="text">
                                <p>
                                    Con il termine <b>welfare aziendale</b> s'intende <b>l’insieme delle iniziative di natura contrattuale o regolamentare, fornite da un’azienda, e volte a incrementare il benessere del lavoratore</b> e della sua famiglia attraverso la corresponsione di un budget, non liquido, spendibile in servizi di varia natura.
                                </p>
                                <p>
                                    Dal punto di vista dell’azienda il piano welfare è principalmente uno strumento di <b>cura delle risorse umane</b> e fidelizzazione delle stesse così come un segnale da spendere sul mercato del lavoro al fine di attrarre le migliori professionalità. Molto spesso lo stesso piano welfare assume una valenza di <b>branding</b> permettendo all’azienda di comunicare la sua sensibilità sociale e la sua dimensione innovativa.
                                </p>
                                <p>
                                    Tutti questi obiettivi possono essere ottenuti beneficiando del <b>vantaggioso regime fiscale</b> riservato alle misure di welfare e definito dal Testo Unico delle Imposte sui Redditi. L’estrema sintesi della <b>dimensione fiscale</b> del welfare aziendale italiano, varato nella sua forma attuale, con la legge finanziaria del 2016, è che a fronte di 1€ lordo di credito welfare attribuito al lavoratore, questi ne percepisce un valore netto di 1€ con un costo azienda complessivo pari ad 1€.
                                </p>
                                <p>
                                    Si tratta in pratica di una <b>totale defiscalizzazione</b> ottenibile a fronte di una condizione essenziale, ovvero che quell’euro non venga liquidato ma speso direttamente in servizi messi a disposizione dall’azienda. L’azienda può mettere i servizi di welfare a disposizione del lavoratore direttamente (ad esempio creando un asilo aziendale o un servizio di maggiordomo aziendale), oppure <b>tramite i cosiddetti portali welfare</b> che sono degli aggregatori di servizi e gestori dei budget welfare dei lavoratori.                                    
                                </p>
                                <p>
                                    Tra i servizi a disposizione possiamo citare le misure generalmente più note al grande pubblico in materia di welfare aziendale:<br>
                                    -    Servizi alla famiglia: asilo, mutui, previdenza, istruzione<br>
                                    -    Servizi alla persona: palestra, sport, shopping, buoni benzina, viaggi<br>
                                    -    Sconti, promozioni, convenzioni per l’accesso a beni e servizi
                                </p>
                                <p>
                                    La materia del welfare aziendale è in continua evoluzione, in particolare rispetto agli aggiornamenti normativi e, soprattutto, in base ai <b>pareri interpretativi</b> con cui costantemente l’Agenzia delle entrate risponde agli <b>interpelli</b> in materia delle imprese.
                                </p>
                                <p>
                                    La prima forma di <b>welfare</b>, in senso lato, nasce in Gran Bretagna subito <b>dopo la Prima Guerra Mondiale</b> con il termine “Welfare State”, utilizzato per indicare che la sicurezza e il benessere sociale ed economico dei cittadini erano responsabilità dello Stato. Impegno che si è tradotto, nei diversi Paesi, specie in quelli europei, in un insieme di politiche pubbliche di assistenza, volte a erogare servizi e benefici per tutelare l’istruzione scolastica e la salute dei cittadini e tamponare i problemi derivanti dai fenomeni della disoccupazione e degli infortuni sul lavoro.
                                </p>
                                <p>
                                    Gli anni ‘70 sancirono l’inizio di una fase di profonda crisi economica che venne fronteggiata con l’implementazione e l’incentivo <b>allo sviluppo del cosiddetto “secondo welfare”</b>. Il Secondo welfare, in cui viene annoverato anche il cosiddetto welfare aziendale, comprende <b>tutte le misure e gli interventi non statali</b>, erogati da una molteplicità di attori privati del mondo profit e non-profit. 
                                </p>
                                <p>
                                    Le normative contenute nella <b>legge di Stabilità del 2016 hanno segnato una nuova era del welfare aziendale</b> nel nostro Paese e rappresentano un punto di partenza per le riforme degli anni successivi in tema di tutele per famiglia e salute, trasporto, benessere e genitorialità.
                                </p>
                                <p>
                                    L’attuale crisi economica causata dall’emergenza sanitaria del <b>Covid-19</b> ha portato alla luce <b>nuove tematiche legate a questo strumento</b>. Le possibili evoluzioni e le misure da introdurre possono essere infinite, e spaziare dallo smart working, nuovi servizi o modalità di fruizioni, fino alla mobilità, proponendo un piano welfare ampio e personalizzabile, adatto a trovare le migliori soluzioni per coprire tutte le nuove esigenze dei dipendenti e delle loro famiglie.
                                </p>
                                <p>
                                    Consolidando una tendenza che si era innescata già prima della pandemia, <b>i lavoratori attribuiscono una sempre maggiore importanza</b>, all’interno della gamma di servizi proposti, a quelli che hanno a che fare con <b>Viaggi e tempo libero</b> che, finiti i tempi in cui erano considerati consumi voluttuari, rappresentano oggi un elemento strutturale e fondamentale del benessere del lavoratore della sua famiglia. Oggi, come mai prima, tempo libero, consumi culturali e viaggi rappresentano la <b>risposta alle esigenze di salute psico-fisica</b> e ai bisogni culturali degli utenti.
                                </p>

                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="image">
                            <div class="image" style="background-image:url('../../../../img/welfare/prefooter.jpg')"></div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import FormContatti from '@/components/blocks/form-contatti'
    import ScrollTo from '@/components/atoms/scroll-to'
    //import SvgChevronLeft from '@/components/svg/chevron-left'
   // import SvgChevronRight from '@/components/svg/chevron-right'
    
    export default {
        name: 'welfare',
        metaInfo: {
          title: 'Welfare aziendale - Soluzioni di online travel booking',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Viaggi incentive - Soluzioni di online travel booking' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
          ],
        },
        components: {
            Slick,
            FormContatti,
            ScrollTo,
            //SvgChevronLeft,
            //SvgChevronRight,
        },
        data()
        {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots:false,
                    fade:true,
                    arrows:true,
                    autoplay:true,
                    speed: 1500,
                    autoplaySpeed: 5500,
                    prevArrow: '#hero-slider-prev',
                    nextArrow: '#hero-slider-next',
                    responsive: [{
                        /*
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                        */
                    }]
                },
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
                bSlickOptions2: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left-2',
                        nextArrow: '#b-right-2',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    #welfare
    {
        .hero-drops
        {
            width:100%;
            overflow:hidden;
            max-width:1920px;
            position:relative;

            .drop-gray-1
            {
                position:absolute;
                top:46px;
                left:25%;
                width:46px;
                height:auto;
            }

            .drop-gray-2
            {
                position: absolute;
                top: 75%;
                left: 40%;
                width: 40px;
                height: auto;
            }

            .slider
            {
                position:relative;
                &--nav
                {
                    position:absolute;
                    padding:5px;
                    bottom:0;
                    display:flex;
                    .arrow
                    {
                        cursor:pointer;
                        transition:$transition-base;
                        &:hover
                        {
                            opacity:0.7;
                        }
                        path
                        {
                            stroke:$secondary;
                        }
                    }
                    @include media-breakpoint-up(lg)
                    {
                        right:0;
                        bottom:60px;
                        left:auto;
                        .arrow
                        {
                            padding:10px 20px;
                            svg
                            {
                                height:auto;
                                width:40px;
                            }
                        }
                    }
                }
            }
            .slide
            {
                //background-size: contain;
                //background-position: center center;
                //min-height: 200px;
                width:100%;
                //border:1px solid red;
                display:flex !important; //altrimenti slick, as usual, la sovrascrive con inline-block
                justify-content: flex-end;
            }
            .image
            {
                width:55%;
                position:relative;
                margin:30px 0;
                transform:translateX((5%))
            }
            .thumb
            {
                height: auto;
                width:100%;
            }
            .caption
            {
                position:absolute;
                top:50%;
                left:0;
                width:45%;
                //transform:translateY(-50%);
                padding:$grid-gutter-width/6;
                //border:1px solid green;
            }
            .small
            {
                color:$dark-blue;
                display:none;
                //font-weight: 400;
            }
            .text
            {
                //margin:0.25rem 0;
                color:$tertiary;
            }

            @include media-breakpoint-up(sm)
            {
                margin-bottom:80px;
                .drop-gray-1
                {
                    width:65px;
                    left:18.5%;
                    top:26.5%;
                }
                .drop-gray-2
                {
                    top: 82%;
                    left: 40%;
                    width: 60px;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    width:60%;
                    margin:0;
                    transform:translateX(5%) translateY(-3.5%);
                }
                .thumb
                {
                }
                .caption
                {
                    padding: 0;
                    padding-left:$grid-gutter-width/2;
                    font-size:16px;
                    top:auto;
                    bottom:0;
                    width:30%;
                }
                .small
                {
                    display:block;
                    max-width:220px;
                }
                .text
                {
                    margin:0.5rem 0;
                }
            }

            @include media-breakpoint-up(lg)
            {
                .drop-gray-1
                {
                    width: 160px;
                    left: 5.5%;
                    top: 0;
                }
                .drop-gray-2
                {
                    top: 80%;
                    left: 30%;
                    width: 80px;
                }
                .caption
                {
                    bottom:auto;
                    top:50%;
                    transform: translateY(-30%);
                    width:50%;
                }
                .small
                {
                    max-width:400px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    max-width:680px;
                }                    
            }

            @include media-breakpoint-up(xxl)
            {

                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    //width:60vw;
                    //transform:none;
                    max-width:1200px;
                    top:0px;
                }
                .thumb
                {
                    top:4px;
                }
                .caption
                {
                    padding:0;
                    margin:0 $grid-gutter-width*2;
                    //font-size:16px;
                    transform:translateY(-50%);
                }
                .small
                {
                    max-width:560px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    max-width:700px;
                }                    
            }            
        }

        .boxed-text
        {
            margin-top:0;
            margin-bottom:0;
            padding-top:0;
            padding-bottom:0;
        }

        .extraQuote
        {
            margin-top:0;
            padding-top:0;
            .text
            {
                font-size: 9px;
                line-height: 1;
                top:38%;
                left:37.5%;
                transform:translateY(-50%);
                width:50%;
                @include media-breakpoint-up(sm)
                {
                    top:42%;
                    font-size: 14px;
                    line-height: 1.4;
                }
                @include media-breakpoint-up(lg)
                {
                    top:40%;
                    font-size: 18px;
                    line-height: 1.4;
                }
                @include media-breakpoint-up(xl)
                {
                    
                    left:42%;
                    width:40.5%;
                    line-height: 1.6;
                    font-size: 20px;
                }
                @include media-breakpoint-up(xxl)
                {
                    
                    left:42%;
                    width:33.5%;
                    line-height: 1.6;
                    font-size: 20px;
                }
            }
        }   
        
        .credito-travel
        {
            padding-top:0 !important;
            margin-bottom:0 !important;
            .title
            {
                color:$dark-blue;
                text-align: center;
                position:absolute;
                top:27%;
                padding:0 4%;
                font-weight: bold;
            }

            .drop
            {
                margin-top:-40px;
            }

            @include media-breakpoint-up(md)
            {
                .title
                {
                    width:100%;
                }
            }
            @include media-breakpoint-up(xl)
            {
                .title
                {
                    width:100%;
                }
                .drop
                {
                    max-width: 520px;
                    bottom:80px;
                }
            }
        }

        .section--card-with-background
        {
            @include media-breakpoint-up(sm)
            {
                .card
                {
                    width:calc(50% - #{$grid-gutter-width});
                }

                .card:nth-child(3)
                {

                }

                .card:nth-child(2),
                .card:nth-child(4)
                {
                    transform:translateY(15%);
                }
            }
            @include media-breakpoint-up(lg)
            {
                padding-top:280px;
            }
        }

        .section--prefooter
        {
            .image
            {
                background-position: center center;
            }
        }
    }
</style>